import styled from 'styled-components'

import MediaWrapper from 'components/cards/shared/MediaWrapper'
import CollectionCard from 'components/cards/CollectionCard'

const Outer = styled.div`
  width: 100%;
  position: relative;
  border-radius: 6px;
`

type CollectionSlideProps = {
  item: {
    id: string
    name: string
    slug: string
    image?: Pick<GQL_Collection['image'], 'large' | 'medium'>
  }
}

// CollectionCard is itself the anchor — don't wrap it in another <a> (nested
// anchors are invalid markup and break SSR hydration).
const CollectionSlide = ({ item }: CollectionSlideProps) => {
  const { name, slug, image } = item

  return (
    <Outer>
      <CollectionCard name={name} slug={slug} image={image} />
    </Outer>
  )
}

export const PlaceholderCollectionSlide = () => {
  return (
    <Outer>
      <MediaWrapper portrait rounded />
    </Outer>
  )
}

export default CollectionSlide
